import { CommonInputControlsProps, StyleVariant } from "./types";
import { ChangeInputHandler } from "../../../helpers/functions/types";
import { FC } from "react";
import { NAMED_WRAPPER_STYLES } from "./constants";
import { LabelAtom } from "./atoms/LabelAtom";
import { TextInputAtom } from "./atoms/TextInputAtom";

type NamedTextInputProps = CommonInputControlsProps<
  string,
  ChangeInputHandler
> & {
  type?: React.HTMLInputTypeAttribute;
  textArea?: boolean;
  pattern?: string;
  placeholder?: string;
};

const NAMED_TEXTINPUT_WRAPPER_STYLES: Record<StyleVariant, string | undefined> =
  {
    newPage: `${NAMED_WRAPPER_STYLES} flex-wrap gap-5 px-4 text-sm py-4`,
    detailPage: "",
    slideOver: `${NAMED_WRAPPER_STYLES} min-h-fit w-full flex-wrap gap-5 text-sm px-4`,
    srLabel: "",
  };

export const NamedTextInput: FC<NamedTextInputProps> = ({
  title,
  value,
  onChange,
  disabled,
  permissions,
  customId,
  required,
  capitalize = true,
  styleVariant = "slideOver",
  type,
  textArea,
  pattern,
  placeholder,
}) => {
  const itemId = customId ?? title;

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={NAMED_TEXTINPUT_WRAPPER_STYLES[styleVariant]}
    >
      <LabelAtom
        title={title}
        htmlFor={itemId}
        srOnly={styleVariant === "srLabel" || styleVariant === "detailPage"}
        capitalize={capitalize}
      />
      <TextInputAtom
        name={itemId}
        onChange={onChange}
        disabled={disabled}
        required={required}
        value={value}
        permissions={permissions}
        styleVariant={styleVariant}
        type={type}
        textArea={textArea}
        pattern={pattern}
        placeholder={placeholder}
      />
    </div>
  );
};
